module.exports = __webpack_public_path__ + "static/media/BALANCE.f012a43e.png";